/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsReceivedReviewIssueRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.received.review.issue',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsReceivedReviewIssueRoute);
